export enum MessageType {
   CreateChannel = 4,
   CloseChannel = 8,
   RawBinaryData = 16,
   RawStringData = 32,
   Data = 64,
}
